import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { PhoneCode } from "../../Components";
import AutoComplete from "../AutoComplete";
import Loader from "../../Components/Loader";
import { WebRetailerService } from "../../Services/WebLinkRetailer";
import { CategoryService, SubCategoryService } from "../../Services";
import { toast } from "react-toastify";
import CropImageDialog from "./CropImageDialog";
import "./box.css";

import { Button } from "react-bootstrap-v5";
const REACT_APP_API_ENDPOINT = process.env.REACT_APP_API_BASEURL;

export const EditWebLinkRetailer = () => {
  const [active, setActive] = useState();
  const [category, setCategory] = useState([]);
  const [selectedcat, setSelectedcat] = useState();
  const [loader, setLoader] = useState(false);
  const [singleretailer, setSingleretailer] = useState([]);
  const [catdetail, setCatdetail] = useState([]);
  const [selcatid, setSelcatid] = useState();
  const [retailerlogo, setRetailerlogo] = useState();
  const [image, setImage] = useState("");
  const [cropModal, setCropModal] = useState(false)
  const [valimg, setValimg] = useState(false);
  const history = useHistory();

  const [location, setLocation] = useState();

  const singleId = history.location.search;

  const getcat = async () => {
    await CategoryService.getCategory()
      .then((res) => {
        setCategory(res?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSinglecat = async (e) => {
    formik.setValues({
      ...formik.values,
      category_id: e.value,
    });
    setSelcatid(e.value);
    let obj = {id : e.value };
    await CategoryService.getCategory(obj)
      .then((res) => {
        setCatdetail(res?.data[0]?.sub_categories);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlesubcatChange = async (e) => {
    formik.setValues({
      ...formik.values,
      subcategory_id: e.value,
    });
  };

  const categoryList =
    category &&
    category.map((item, index) => {
      return {
        value: item._id,
        label: item.category_name,
      };
    });

  const subcatList =
    catdetail &&
    catdetail.map((item, index) => {
      return {
        value: item._id,
        label: item.subcategory_name,
      };
    });

  const getData = async () => {
    let id = singleId.split("=");
    let obj = { id: id[1] };
    await WebRetailerService.getWebLinkRetailer(obj)
      .then((res) => {
        setActive(res?.data[0]?.is_discount);
        setSelcatid(res?.data[0]?.category_id);
        handleSinglecat({ value: res?.data[0]?.category_id });
        setRetailerlogo(res?.data[0]?.retailer_logo);
        setSelectedcat(res?.data[0]?.subcategory_id);
        setSingleretailer(res?.data);
        formik.setFieldValue("subcategory_id", res?.data[0]?.subcategory_id);
        formik.setFieldValue("name", res?.data[0]?.name);
        formik.setFieldValue("retailer_logo", res?.data[0]?.retailer_logo);
        formik.setFieldValue("email", res?.data[0]?.email);
        formik.setFieldValue("contact_number", res?.data[0]?.contact_number);
        formik.setFieldValue("sale_discount", res?.data[0]?.sale_discount);
        formik.setFieldValue("country", res?.data[0]?.country);
        formik.setFieldValue("city", res?.data[0]?.city);
        formik.setFieldValue("url", res?.data[0]?.url);
        formik.setFieldValue(
          "retailer_discription",
          res?.data[0]?.retailer_discription
        );
        formik.setFieldValue("location", res?.data[0]?.location);
        setImage({imageurl:(REACT_APP_API_ENDPOINT + "/" + res?.data[0]?.retailer_logo) , image:""})
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      contact_number: "",
      sale_discount: "",
      retailer_logo: "",
      subcategory_id: "",
      country: "",
      city: "",
      url: "",
      retailer_discription: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        // .matches(/^[A-Za-z ]*$/, "Please enter valid name")
        .required("Required"),
      country: Yup.string().required("Required"),
      city: Yup.string().required("Required"),
      retailer_discription: Yup.string().required("Required"),
      url: Yup.string().required("Required"),
      subcategory_id: Yup.string().required("Required"),
      retailer_logo: Yup.string().required("Required"),
      location: Yup.string().required("Required"),
      email: Yup.string()
        .required("Required")
        .email("Please enter valid email"),
      contact_number: Yup.string()
        .min(10, "Too short")
        .typeError("Must be a number")
        .required("Required"),
    }),

    onSubmit: async (values) => {
      let id = singleId?.split("=");
      let obj = { id: id[1] };

      let data = new FormData();
      data.append("name", formik.values.name);
      data.append("email", formik.values.email);
      data.append("contact_number", formik.values.contact_number);
      if (active === "ACTIVE") {
        data.append("sale_discount", formik.values.sale_discount);
      }
      if (typeof values.retailer_logo !== "string") {
        data.append("retailer_logo", values.retailer_logo);
      }
      data.append("subcategory_id", formik.values.subcategory_id);
      data.append("country", formik.values.country);
      data.append("city", formik.values.city);
      data.append("url", formik.values.url);
      data.append("location", formik.values.location);
      if (active) {
        data.append("is_discount", active);
      }
      data.append("retailer_discription", formik.values.retailer_discription);
      data.append("category_id", formik.values.category_id);
      data.append("id", id[1]);

      setLoader(true);
      await WebRetailerService.editRetailer(data)
        .then((res) => {
          if (res.status === true) {
            toast.success(res.message);
            history.push("/web-link-retailer-list");
          }
          setLoader(false);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const handleCheck = (e) => {
    if (e.target.checked) {
      setActive(e.target.value);
      formik.setValues({
        ...formik.values,
        is_discount: e.target.value,
      });
    } else {
      formik.setValues({
        ...formik.values,
        is_discount: "INACTIVE",
      });
      setActive("INACTIVE");
    }
  };

  useEffect(() => {
    getcat();
    getData();
  }, []);




  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-8">
        <div className="card">
          <div className="card-body">
            <form className="control-form">
              <div className="row">
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Category</label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: formik.touched.category
                            ? !formik.errors.category
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      name="category"
                      value={categoryList?.filter(
                        ({ value }) => value === selcatid
                      )}
                      onChange={(e) => {
                        handleSinglecat(e);
                      }}
                      options={categoryList}
                    />
                    {formik.touched.category && formik.errors.category ? (
                      <div className="text-danger">
                        {formik.errors.category}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Sub Category</label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: formik.touched.subcategory_id
                            ? !formik.errors.subcategory_id
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      name="subcategory_id"
                      value={subcatList?.filter(
                        ({ value }) => value === selectedcat
                      )}
                      onChange={(e) => {
                        setSelectedcat(e.value);
                        handlesubcatChange(e);
                      }}
                      options={subcatList}
                    />
                    {formik.touched.subcategory_id &&
                    formik.errors.subcategory_id ? (
                      <div className="text-danger">
                        {formik.errors.subcategory_id}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Name</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      className={
                        "form-control" +
                        (formik.touched.name
                          ? !formik.errors.name
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("name")}
                      placeholder="Enter Name"
                    />
                    {formik.touched.name && formik.errors.name ? (
                      <div className="text-danger">{formik.errors.name}</div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Contact No.</label>
                  </div>
                  <div className="col-9">
                    <div
                      className={
                        formik.touched.contact_number
                          ? !formik.errors.contact_number
                            ? " contact-success"
                            : " contact-error"
                          : ""
                      }
                    >
                      <PhoneCode
                        Addphone={(value) =>
                          formik.setValues({
                            ...formik.values,
                            contact_number: value,
                          })
                        }
                        phone={formik.values.contact_number}
                      />
                    </div>
                    {formik.touched.contact_number &&
                    formik.errors.contact_number ? (
                      <div className="text-danger">
                        {formik.errors.contact_number}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Email ID</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="email"
                      className={
                        "form-control" +
                        (formik.touched.email
                          ? !formik.errors.email
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("email")}
                      placeholder="Enter Email"
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="text-danger">{formik.errors.email}</div>
                    ) : null}
                  </div>
                </div>

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Logo</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="file"
                      name="retailer_logo"
                      className={
                        "form-control" +
                        (formik.touched.retailer_logo
                          ? !formik.errors.retailer_logo
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      onChange={(e) => {
                        if(e.target.files[0].name.split(".").at(-1) === "svg"){
                          setValimg(true)
                        }else{
                          setValimg(false)
                        formik.setFieldValue(
                          "retailer_logo",
                          e.target.files[0]
                        );
                        // setImage(URL.createObjectURL(e.target.files[0]));
                        setImage({imageurl:URL.createObjectURL(e.target.files[0]),image:e.target.files})

                        }
                      }}
                    />
                     {
                      valimg === true &&
                    <p className="text-danger">Uploaded file has unsupported format</p>
                    }
                    {formik.touched.retailer_logo &&
                    formik.errors.retailer_logo ? (
                      <div className="text-danger">
                        {formik.errors.retailer_logo}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-sm-3"></div>
                  <div className="col-sm-9">
                  <div className="Retailer-name ">
                    <div className="retaler-images w-100 h-100">
                    {(image && (
                      <img style={{ width:'100%', height:'100%' }} src={image.imageurl} />
                    )) || (
                      <img
                        style={{ width:'100%', height:'100%'}}
                        src={REACT_APP_API_ENDPOINT + "/" + retailerlogo}
                      />
                    )}
                    </div></div>
                    <Button style={{marginLeft : 58}} className="mt-2" onClick={()=> setCropModal(true)}>crop</Button>
                    {cropModal &&
                    <CropImageDialog
                      cropModal={cropModal}
                      imagedata={image}
                      setNewImage={setImage}
                      setCropModal={setCropModal}
                      setFieldValue={formik.setFieldValue}
                  />
                    }
                 
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-sm-3">
                    {" "}
                    <label className="form-label">Offer</label>
                  </div>
                  <div className="col-sm-9 row ms-1">
                    <div className="form-check col-sm-2">
                      <input
                        onChange={(e) => {
                          handleCheck(e);
                        }}
                        className="form-check-input"
                        type="checkbox"
                        checked={active === "ACTIVE" ? true : false}
                        value="ACTIVE"
                        id="flexCheckDefault"
                      />
                      <label className="form-check-label" htmlFor="flexCheckDefault">
                        Active
                      </label>
                    </div>
                  </div>
                </div>

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Offer detail</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      name="sale_discount"
                      className={
                        "form-control" +
                        (formik.touched.sale_discount
                          ? !formik.errors.sale_discount
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("sale_discount")}
                      placeholder="Enter Discount"
                    />
                    {formik.touched.sale_discount &&
                    formik.errors.sale_discount ? (
                      <div className="text-danger">
                        {formik.errors.sale_discount}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Retailer Website</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      className={
                        "form-control" +
                        (formik.touched.url
                          ? !formik.errors.url
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("url")}
                      placeholder="Enter URL"
                    />
                    {formik.touched.url && formik.errors.url ? (
                      <div className="text-danger">{formik.errors.url}</div>
                    ) : null}
                  </div>
                </div>

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">City</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      className={
                        "form-control" +
                        (formik.touched.city
                          ? !formik.errors.city
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("city")}
                      placeholder="Enter City"
                    />
                    {formik.touched.city && formik.errors.city ? (
                      <div className="text-danger">{formik.errors.city}</div>
                    ) : null}
                  </div>
                </div>

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Country</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      className={
                        "form-control" +
                        (formik.touched.country
                          ? !formik.errors.country
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("country")}
                      placeholder="Enter Country"
                    />
                    {formik.touched.country && formik.errors.country ? (
                      <div className="text-danger">{formik.errors.country}</div>
                    ) : null}
                  </div>
                </div>

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Location</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      name="location"
                      className={
                        "form-control" +
                        (formik.touched.location
                          ? !formik.errors.location
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("location")}
                      placeholder="Enter Location"
                    />
                    {formik.touched.location && formik.errors.location ? (
                      <div className="text-danger">
                        {formik.errors.location}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Description</label>
                  </div>
                  <div className="col-9">
                    <textarea
                      required={false}
                      type="textarea"
                      className={
                        "form-control" +
                        (formik.touched.retailer_discription
                          ? !formik.errors.retailer_discription
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("retailer_discription")}
                      placeholder="Type description"
                    ></textarea>
                    {formik.touched.retailer_discription &&
                    formik.errors.retailer_discription ? (
                      <div className="text-danger">
                        {formik.errors.retailer_discription}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mt-3 d-flex justify-content-between">
                <button
                  className="btn btn-danger w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => formik.handleSubmit()}
                >
                  Submit
                </button>
              </div>
            </form>
            <Loader isShow={loader} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditWebLinkRetailer;
